import { config } from '@onflow/fcl';

config({
  'accessNode.api': 'https://rest-testnet.onflow.org', // Mainnet: "https://rest-mainnet.onflow.org"
  'discovery.wallet': 'https://fcl-discovery.onflow.org/testnet/authn', // Mainnet: "https://fcl-discovery.onflow.org/authn"
  '0xLoveJulesLeather': '0x3593499e2fbd34e3', // Yes Jules Testnet contract address
  '0xLoveJulesLeatherMarket': '0x3593499e2fbd34e3',
  '0xChapter2Bikes': '0xd8144e7c81e68eb9',
});
